import { VariableType } from 'json-to-graphql-query';
import type { FieldValue } from './types';

export interface FormatNodeTypeResult {
  id: FieldValue;
  online: FieldValue;
  fmtType:
    | {
        id: FieldValue;
        name: FieldValue;
      }
    | false;
}

export const FormatNodeType = (truify: boolean = false): FormatNodeTypeResult => ({
  id: truify,
  online: truify,
  fmtType: truify
    ? {
        id: truify,
        name: truify,
      }
    : false,
});

interface AllFormatsQueryResult {
  query: {
    __variables: {
      asset_Id: 'ID';
      fmtType_Slug: 'String';
      asset_Items_ObjectId: 'Int';
    };
    allFormats: {
      totalCount: FieldValue;
      __args: {
        asset_Id: VariableType;
        fmtType_Slug: VariableType;
        asset_Items_ObjectId: VariableType;
      };
      edges: {
        node: FormatNodeTypeResult;
      };
    };
  };
}

export const allFormatsQuery = (truify: boolean = false): AllFormatsQueryResult => ({
  query: {
    __variables: {
      asset_Id: 'ID',
      fmtType_Slug: 'String',
      asset_Items_ObjectId: 'Int',
    },
    allFormats: {
      totalCount: truify,
      __args: {
        asset_Id: new VariableType('asset_Id'),
        fmtType_Slug: new VariableType('fmtType_Slug'),
        asset_Items_ObjectId: new VariableType('asset_Items_ObjectId'),
      },
      edges: {
        node: { ...FormatNodeType(truify) },
      },
    },
  },
});

interface FormatsQueryResult {
  query: {
    __variables: {
      asset_Id: 'ID';
      asset_Items_ObjectId: 'Int';
      fmtType_Slug: 'String!';
    };
    formats: FormatNodeTypeResult & {
      __args: {
        assetId: VariableType;
        itemId: VariableType;
        fmtTypeSlug: VariableType;
      };
    };
  };
}

export const formatsQuery = (truify: boolean = false): FormatsQueryResult => ({
  query: {
    __variables: {
      asset_Id: 'ID',
      asset_Items_ObjectId: 'Int',
      fmtType_Slug: 'String!',
    },
    formats: {
      __args: {
        assetId: new VariableType('asset_Id'),
        itemId: new VariableType('asset_Items_ObjectId'),
        fmtTypeSlug: new VariableType('fmtType_Slug'),
      },
      ...FormatNodeType(truify),
    },
  },
});
